import { jsx as _jsx } from "react/jsx-runtime";
import { BlockContext } from '../contexts/block';
export const connectBlock = (Component, options) => {
    const MyComp = props => {
        return (_jsx(BlockContext.Provider, { value: options, children: _jsx(Component, { ...props }) }));
    };
    MyComp.options = options;
    return MyComp;
};
